module.exports = __webpack_public_path__ + "static/media/underconst.587a181d.svg";